angular.module('affiliateCompanyAdd', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/affiliate-company-add/affiliate-company-add.module.js